var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var ReviewsPage = function () {
            function ReviewsPage(reviewsType) {
                _classCallCheck(this, ReviewsPage);

                this.currentType = reviewsType;
                this.isSearch = false;
                this.autoCompleteTimerDebounce = 300;
                this.autoCompleteTimer = 0;

                this.$form = $('#hotel-search-form');
                this.$inputHotelId = this.$form.find('[name="hotel_id"]');
                this.$inputSearch = this.$form.find('.hotel_name');

                this.init();
            }

            _createClass(ReviewsPage, [{
                key: "init",
                value: function init() {
                    this.attachAutocompleteHandlers();
                    if (this.currentType === 'audio') {
                        this.prototypeJqueryAudioReview();
                        $('.audio-review').audioReview();
                        $('.arc-progress-bar').slider({ min: 0, range: 'min' });
                        $('.arc-volume-bar').slider({ min: 0, max: 1, range: 'min', step: 0.1, value: 0.7 });
                    }
                }
            }, {
                key: "attachAutocompleteHandlers",
                value: function attachAutocompleteHandlers() {
                    var _this = this;

                    var selfPage = this;

                    this.$inputSearch.on('keyup', function (e) {
                        selfPage._onHotelNameEnter(e.currentTarget);
                    });
                    this.$form.on('submit', function (e) {
                        if (_this.$inputSearch.val() == '' || _this.$inputHotelId.val() == '') {
                            return false;
                        }
                    }).on('click', '.hotels-item', function (e) {
                        _this.isSearch = false;
                        selfPage.hideDropDownList();

                        var $self = $(e.currentTarget);
                        var hotelName = $self.text();
                        var hotelId = $self.data('id');

                        _this.$inputSearch.val(hotelName).addClass('selected');
                        _this.$inputHotelId.val(hotelId);
                        _this.$form.submit();
                    });

                    $('body').on('click', function (e) {
                        var $elem = $(e.target);
                        if (selfPage.isSearch && 0 === $elem.closest('.form_container').length && !$elem.hasClass('hotels-item')) {
                            _this.$inputSearch.val('').removeClass('selected');
                            _this.$inputHotelId.val('');
                            selfPage.hideDropDownList();
                            selfPage.isSearch = false;
                        }
                    });
                }
            }, {
                key: "_onHotelNameEnter",
                value: function _onHotelNameEnter(input) {
                    var _this2 = this;

                    if (this.autoCompleteTimer) {
                        clearTimeout(this.autoCompleteTimer);
                    }
                    this.autoCompleteTimer = setTimeout(function () {
                        _this2._searchHotelsByName(input);
                    }, this.autoCompleteTimerDebounce);
                }
            }, {
                key: "_searchHotelsByName",
                value: function _searchHotelsByName(input) {
                    var _this3 = this;

                    this.isSearch = true;
                    var $input = $(input);
                    $input.removeClass('selected');
                    var value = $input.val();
                    if (value.length > 3) {
                        $.getJSON('/find-form/get-hotels', { query: value }, function (data) {
                            if (data.list.length === 0) {
                                _this3.hideDropDownList();
                                return;
                            }
                            var html = '';
                            var hotels = data.list;
                            var i = void 0;
                            for (i in hotels) {
                                html += '<div data-id="' + hotels[i]['id'] + '" class="hotels-item">' + hotels[i]['label'] + '</div>';
                            }
                            $('.hotels_dropdown').html(html);
                            _this3.showDropDownList();
                        });
                    } else {
                        this.hideDropDownList();
                    }
                }
            }, {
                key: "hideDropDownList",
                value: function hideDropDownList() {
                    $('.hotels_dropdown').addClass('hide');
                    $('.form_container').removeClass('dropdown');
                }
            }, {
                key: "showDropDownList",
                value: function showDropDownList() {
                    $('.hotels_dropdown').removeClass('hide');
                    $('.form_container').addClass('dropdown');
                }
            }, {
                key: "prototypeJqueryAudioReview",
                value: function prototypeJqueryAudioReview() {
                    (function ($) {
                        var methods = {
                            init: function init() {
                                return this.each(function () {
                                    var $this = $(this);
                                    var $arc = $this.closest('.audio-review-controls');
                                    var $duration = $arc.find('.arc-duration');
                                    $duration.text(humanTime($this.data('duration')));

                                    $arc.on('click', '.btn-play', play).on('click', '.btn-pause', pause).on('click', '.arc-volume-icon', mute);

                                    $('.arc-progress-bar').on("slide", rewind);
                                    $('.arc-volume-bar').on("slide", function (event, ui) {
                                        var $this = $(this);
                                        var $control = $this.closest('.audio-review-controls');
                                        var $audio = $control.find('.audio-review');
                                        var $volumeVal = $control.find('.arc-volume');
                                        $audio.prop('volume', ui.value);
                                        $volumeVal.text(ui.value * 100 + '%');
                                        $this.data('volume', ui.value * 100);
                                    });
                                });
                            }
                        };

                        function play() {
                            var $this = $(this);
                            var dataId = $this.data('id');
                            var $audio = $('#' + dataId);
                            var $controlsWrapper = $audio.closest('.audio-review-controls');
                            var $timeline = $controlsWrapper.find('.arc-progress-bar');
                            var duration = $audio.data('duration');
                            var width = $timeline.width() - 9;
                            var $ct = $controlsWrapper.find('.arc-current-time');

                            var $audioPlayed = $('body').find('.btn-pause').closest('.audio-review-controls').find('audio');
                            if ($audioPlayed.length > 0) {
                                $audioPlayed.trigger('pause');
                                var $audioPlayedBar = $audioPlayed.siblings('.arc-progress-bar');
                                $audioPlayedBar.find('.ui-slider-range').css('width', 0);
                                $audioPlayedBar.find('.ui-slider-handle').css('left', 0);
                                $audioPlayed.prop({ 'currentTime': 0 });
                                $audioPlayed.siblings('.arc-current-time').text('00:00');
                                $('body').find('.btn-pause').addClass('btn-play').removeClass('btn-pause');
                            }
                            $audio.trigger('play');
                            $this.removeClass('btn-play');
                            $this.addClass('btn-pause');
                            var progressBar = setInterval(function () {
                                var currentTime = $audio.prop('currentTime');
                                var loaded = width * currentTime / duration;
                                $ct.text(humanTime(currentTime));
                                $timeline.find('.ui-slider-range').css('width', loaded + 'px');
                                $timeline.find('.ui-slider-handle').css('left', loaded + 'px');
                                if (parseInt(currentTime, 10) === duration) {
                                    clearInterval(progressBar);
                                    setTimeout(function () {
                                        $timeline.find('.ui-slider-range').css('width', 0);
                                        $timeline.find('.ui-slider-handle').css('left', 0);
                                        $ct.text('00:00');
                                        $this.addClass('btn-play');
                                        $this.removeClass('btn-pause');
                                    }, 500);
                                }
                            }, 1000);
                        }

                        function pause() {
                            var $this = $(this);
                            var dataId = $this.data('id');
                            var $audio = $('#' + dataId);
                            $audio.trigger('pause');
                            $this.addClass('btn-play');
                            $this.removeClass('btn-pause');
                        }

                        function rewind(e, ui) {
                            var $this = $(this);
                            var $audioTime = $this.closest('.audio-review-controls').find('.audio-review');
                            var duration = $audioTime.prop('duration');
                            if (duration > 0) {
                                var offset = $this.offset();
                                var left = e.clientX ? e.clientX - offset.left : ui.value;
                                var width = $this.width();
                                $(this).find('.arc-bar-loaded').css('left', left + 'px');
                                $audioTime.prop('currentTime', duration * left / width);
                            }
                        }

                        function mute(e) {
                            var $this = $(this);
                            var $control = $this.closest('.audio-review-controls');
                            var $audio = $control.find('.audio-review');
                            var $volumeVal = $control.find('.arc-volume');
                            var $volumeLine = $control.find('.arc-volume-bar');
                            if ($this.hasClass('mute')) {
                                $this.removeClass('mute');
                                volume = $volumeLine.data('volume');
                            } else {
                                $this.addClass('mute');
                                var volume = 0;
                            }
                            $audio.prop('volume', volume / 100);
                            $volumeVal.text(volume + '%');
                            $volumeLine.find('.ui-slider-range').css('width', volume + '%');
                            $volumeLine.find('.ui-slider-handle').css('left', volume + '%');
                        }

                        function humanTime(time) {
                            var sec, min;
                            sec = Math.floor(time);
                            min = Math.floor(sec / 60);
                            min = min >= 10 ? min : '0' + min;
                            sec = Math.floor(sec % 60);
                            sec = sec >= 10 ? sec : '0' + sec;
                            return min + ':' + sec;
                        }

                        $.fn.audioReview = function (method) {
                            if (methods[method]) {
                                return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
                            } else if ((typeof method === "undefined" ? "undefined" : _typeof(method)) === 'object' || !method) {
                                return methods.init.apply(this, arguments);
                            }
                        };
                    })(window.jQuery);
                }
            }]);

            return ReviewsPage;
        }();

        window.ReviewsPage = ReviewsPage;
    }, {}] }, {}, [1]);